/** Shared rupee / tone / day formatting for the report pages.
 *
 * Extracted when the comparison table moved to its own file: both it
 * and `reportWidgets` render the same money, and two copies drift. */

export function tone(v: number): string | undefined {
  if (v > 0) return "text-success";
  if (v < 0) return "text-danger";
  return undefined;
}

export function rupees(v: number): string {
  return `Rs ${Math.round(v).toLocaleString("en-IN")}`;
}

export function signedRupees(v: number): string {
  let sign = "";
  if (v > 0) sign = "+";
  if (v < 0) sign = "-";
  return `${sign}Rs ${Math.abs(Math.round(v)).toLocaleString("en-IN")}`;
}

export function dayLabel(iso: string | null): string {
  if (iso === null) return "";
  return new Date(iso.length === 10 ? `${iso}T00:00:00+05:30` : iso).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    timeZone: "Asia/Kolkata",
  });
}
